/**
 * AIChatWidget - Embeds AI Chat in the widget system
 */

import React, { useState, useCallback } from 'react';
import { WidgetWrapper } from './WidgetWrapper';
import { AdaptiveModal } from '../AdaptiveModal';
import { AIChat } from '../ai/AIChat';
import type { AIChatWidgetConfig } from '../../types/widgets';

interface AIChatWidgetProps {
  config: AIChatWidgetConfig;
  widgetId: string;
  windowId: string;
}

export function AIChatWidget({ widgetId, windowId }: AIChatWidgetProps) {
  const [expanded, setExpanded] = useState(false);

  const handleHeaderClick = useCallback(() => {
    setExpanded(true);
  }, []);

  const handleClose = useCallback(() => {
    setExpanded(false);
  }, []);

  return (
    <>
      <WidgetWrapper title="AI Chat" widgetId={widgetId} windowId={windowId} onHeaderClick={handleHeaderClick}>
        <AIChat compact className="h-full border-0 shadow-none rounded-none" />
      </WidgetWrapper>
      {expanded && (
        <AdaptiveModal isOpen onClose={handleClose} title="AI Chat" size="xl">
          <div className="max-h-[80vh] overflow-auto">
            <AIChat
              compact={false}
              className="h-full border-0 shadow-none rounded-none"
            />
          </div>
        </AdaptiveModal>
      )}
    </>
  );
}
